export default function VlrLogo({ className = "", title = "VLR Software logo" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 72 72"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18 29 56 43 29"
        fill="none"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 18 41 45 59 11"
        fill="none"
        stroke="#0047FF"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="59" cy="11" r="4" fill="#0047FF" />
    </svg>
  );
}
